import styled from 'styled-components';
import { green60, Typography } from '../../../../styles';

export const GiftDaysWrapper = styled.p`
    ${Typography.Desktop.H70};
    color: ${green60};
`;
